import React from 'react'
import { GallerySendOutlineIcon } from '../AppIcon'
import { Divider } from 'antd'

const DraggerUploadButton = props => {
  const { acceptFileLabel } = props || {}

  return (
    <div>
      <GallerySendOutlineIcon
        style={{
          width: 48,
          height: 48,
          color: '#bac2cb',
        }}
      />
      <p
        style={{
          marginBottom: 6,
          fontSize: 16,
          fontWeight: 600,
        }}>
        Kéo thả file, hình ảnh hoặc{' '}
        <span
          style={{
            color: '#005FAF',
          }}>
          Tải lên
        </span>{' '}
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}>
        <p style={{ fontSize: 14, color: '#7C8694' }}>
          Hỗ trợ: {acceptFileLabel || 'JPG, PNG, PDF, XLS, DOC, PPT'}
        </p>
        <Divider
          type="vertical"
          style={{
            margin: 0,
            height: 20,
            borderColor: '#e5e7eb',
          }}
        />
        <p style={{ fontSize: 14, color: '#7C8694' }}>
          Dung lượng tối đa: 100MB
        </p>
      </div>
    </div>
  )
}

export default DraggerUploadButton
